// Звуки синтезируются через Web Audio (без сторонних файлов/копирайта).
let ctx: AudioContext | null = null;
let muted = false;

function ac(): AudioContext | null {
  try {
    if (!ctx) ctx = new (window.AudioContext || (window as any).webkitAudioContext)();
    if (ctx.state === 'suspended') ctx.resume();
    return ctx;
  } catch {
    return null;
  }
}

function tone(freq: number, dur: number, type: OscillatorType = 'sine', gain = 0.18, slideTo?: number) {
  const c = ac();
  if (!c || muted) return;
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = type;
  o.frequency.setValueAtTime(freq, c.currentTime);
  if (slideTo) o.frequency.exponentialRampToValueAtTime(Math.max(40, slideTo), c.currentTime + dur);
  g.gain.setValueAtTime(gain, c.currentTime);
  g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + dur);
  o.connect(g);
  g.connect(c.destination);
  o.start();
  o.stop(c.currentTime + dur);
}

function noise(dur: number, gain = 0.08) {
  const c = ac();
  if (!c || muted) return;
  const buf = c.createBuffer(1, Math.floor(c.sampleRate * dur), c.sampleRate);
  const d = buf.getChannelData(0);
  for (let i = 0; i < d.length; i++) d[i] = (Math.random() * 2 - 1) * (1 - i / d.length);
  const src = c.createBufferSource();
  const g = c.createGain();
  g.gain.value = gain;
  src.buffer = buf;
  src.connect(g);
  g.connect(c.destination);
  src.start();
}

export const sound = {
  enabled: () => !muted,
  toggle: () => {
    muted = !muted;
    if (!muted) ac();
    return !muted;
  },
  resume: () => ac(),
  spin: () => {
    noise(0.45, 0.06);
    tone(160, 0.4, 'sawtooth', 0.05, 420);
  },
  land: () => tone(320, 0.05, 'square', 0.06),
  cascade: (i: number) => tone(280 + Math.min(i, 8) * 70, 0.12, 'triangle', 0.1),
  win: (level = 0) => {
    const base = 440 * Math.pow(2, Math.min(level, 5) / 12);
    [0, 4, 7].forEach((s, i) => setTimeout(() => tone(base * Math.pow(2, s / 12), 0.18, 'triangle', 0.14), i * 55));
  },
  coin: () => tone(880, 0.08, 'square', 0.09, 1300),
  bigWin: () => {
    [523, 659, 784, 1046, 1318].forEach((f, i) => setTimeout(() => tone(f, 0.35, 'triangle', 0.18), i * 110));
  },
  freeSpins: () => {
    [392, 523, 659, 880].forEach((f, i) => setTimeout(() => tone(f, 0.45, 'sine', 0.2), i * 140));
  },
};
